@for (item of totals; track $index; let first = $first) {
<div class="flex flex-justify-between"
     [ngClass]="totalClass(item.id, first)">
    <label>
        {{item.label | translate}} {{(showSurchargeInfo && item.id === 'shipping') ? 'from' : ''}}
        <!-- optional coupone remove button -->
        @if (allowDiscountRemoval && item.id === 'discount' && basket.data.coupon) {
        <button inlineButton
                [status]="removeDiscountStatus"
                [notification]="'Failed to remove coupon'"
                class="c1 col-b m-l-1 inline-block"
                (click)="removeDiscount()">{{'Remove' | translate}}</button>
        }
    </label>
    <div>
        @if (!item.hideCurrency) {
        <price class="price"
               [useFreeLabel]="true"
               [value]="item.value"></price>{{(showSurchargeInfo && item.id === 'shipping') ? '(+Surcharges)' : ''}}
        } @else {
        <span class="price">{{item.value}}</span>
        }
    </div>
</div>
<!-- temporary coupon breakdown -->
@if (allowDiscountRemoval && item.id === 'giftcards') {
@for (giftcard of (basket.data.giftcards | values); track $index) {
<div class="m-t-1 p-l-4 p1 col-12 left-s">
    {{ getGiftcardLabel(giftcard) }}
    <button inlineButton
            [status]="getGiftcardStatus(giftcard)"
            [notification]="'Failed to remove giftcard'"
            class="c1 col-b m-l-1 inline-block"
            (click)="removeGiftCard(giftcard)">{{'Remove' | translate}}</button>
</div>
}
}
}
@if(info) {
<div class="m-t-2">
    <span class="p2 col-1">{{info}}</span>

    <div class="m-l-2"
         lineHeightBy="p2"><i [style.font-size.px]="24"
           class="icon-faqs pos-relative"
           [style.top.px]="2">
            <tooltip [position]="'top'">
                {{'Subtotal excludes shipping and tax. This is calculated once shipping address information is
                provided.' | translate}}
            </tooltip>
        </i>
    </div>
</div>
}